import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useDonation } from "../Components/DonationContext";
import { useNavigate } from "react-router-dom";

// Animation variants for Framer Motion
const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const staggerItem = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const Leprosy = () => {
  // Data for the initiatives section for cleaner code
  const initiatives = [
    "Rehabilitation & Skill Training",
    "Advocacy to Fight Discrimination",
    "Livelihood Support & Medical Care",
    "Facilitating Access to Government Schemes",
    "Building Self-Help Groups for Collective Action",
  ];

  const { openDonation } = useDonation();
  const navigate = useNavigate();

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/assets/images/sections/Leprosy.jpg)", // Placeholder, update with a relevant image
          }}
        ></div>
        <div className="shape1 float-bob-x">
          <img src="assets/images/shapes/page-header-shape1.png" alt="" />
        </div>
        <div className="shape2">
          <img src="assets/images/shapes/page-header-shape2.png" alt="" />
        </div>
        <Container>
          <div className="page-header__inner text-center">
            <motion.h2
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              Restoring Dignity of Leprosy-affected Persons
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              style={{ color: "#dad2d0", fontSize: "22px", marginTop: "20px" }}
            >
              Dedicatedly supporting leprosy-affected persons and fighting stigma since 1986.
            </motion.p>
          </div>
        </Container>
      </section>

      {/* Introduction Section */}
      <section className="py-5">
        <Container>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={staggerContainer}
          >
            <Row className="align-items-center justify-content-center g-5">
              <motion.div className="col-lg-6" variants={staggerItem}>
                <h2 className="fw-bold mb-4" style={{ color: "#006633" }}>
                  Beyond Treatment: A Mission for Inclusion
                </h2>
                <p className="lh-lg">
                  Since 1986, Vikash has been dedicated to restoring dignity and protecting the fundamental rights of leprosy-affected persons. Through rehabilitation, skill training, and advocacy, we enable affected people to regain confidence and independence. Our mission is to create a society where they live with respect, opportunity, and equal rights.
                </p>
              </motion.div>
              <motion.div className="col-lg-6" variants={staggerItem}>
                <img
                  src="/assets/images/resources/action1.jpg"
                  alt="A leprosy-affected person receiving care"
                  className="img-fluid rounded-5 shadow"
                />
              </motion.div>
            </Row>
          </motion.div>
        </Container>
      </section>

      {/* Key Initiatives Section (NEW) */}
      <section className="py-5 bg-light">
        <Container>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeIn}
            className="text-center mb-5"
          >
            <h2 className="fw-bold" style={{ color: "#006633" }}>
              Our Comprehensive Support System
            </h2>
            <p className="lead">
              We provide a multi-faceted approach to ensure holistic well-being and social inclusion.
            </p>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={staggerContainer}
          >
            <Row className="g-4 justify-content-center">
              {initiatives.map((initiative, index) => (
                <Col md={6} lg={4} key={index}>
                  <motion.div variants={staggerItem}>
                    <Card className="text-center p-3 border-0 shadow-sm h-100">
                      <Card.Body className="d-flex align-items-center justify-content-center">
                        <p className="mb-0">{initiative}</p>
                      </Card.Body>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </motion.div>
        </Container>
      </section>

      {/* Call To Action Section (Reusable) */}
      <section className="py-5 text-dark" style={{ backgroundColor: "#ffffffff" }}>
        <Container className="text-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeIn}
          >
            <h2 className="display-5 fw-bold mb-3">Support the Fight Against Stigma</h2>
            <p className="lead mb-4">
              Your contribution helps provide medical care, rehabilitation, and livelihood support to leprosy-affected individuals.
            </p>
            <Button variant="dark" size="lg" className="me-3 fw-bold" onClick={openDonation}>
              Donate
            </Button>
            <Button variant="outline-dark" size="lg" className="fw-bold" onClick={() => navigate("/interns")}>
              Join Us
            </Button>
          </motion.div>
        </Container>
      </section>

      <Footer />

      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};

export default Leprosy;